import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useBranding } from '@/shared/theme/BrandingProvider';
import styles from './AppShell.module.css';

export function AppShell() {
  useBranding();

  return (
    <div className={styles.shell}>
      <Sidebar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
